
    import {Component, Vue} from 'vue-property-decorator'
    import { toOrderReturn } from '@/utils/h5ToApp'

    @Component({
        name: 'SubmitReturnSuccess',
    })
    export default class SubmitReturnSuccess extends Vue {
        returnOrderId = ''
        returnMoneySum = ''
        currRouteId = ''

        created () {
            this.returnOrderId = this.$route.query.returnOrderId as string
            this.returnMoneySum = this.$route.query.returnMoneySum as string
            this.currRouteId = this.$route.query.currRouteId as string
        }

        toDetail () {
            this.$router.replace({
                path: '/purchaseOrderReturnDetail',
                query: {
                    returnOrderId: this.returnOrderId,
                    currRouteId: this.currRouteId
                }
            })
        }

        toReturnOrderList () {
          this.$router.replace({
            path: '/purchaseOrderList'
          })
          this.$eventBus.$emit('changeToggle', '1')
        }

    }
